import { useLocale } from "@/features/localisation/locale-context";

export function SkipLink() {
  const { locale } = useLocale();
  return (
    <a
      href="#main-content"
      className="rounded-control bg-surface text-primary shadow-subtle fixed left-3 top-3 z-50 -translate-y-20 px-4 py-3 font-semibold focus:translate-y-0"
    >
      {locale === "th" ? "ข้ามไปยังเนื้อหาหลัก" : "Skip to main content"}
    </a>
  );
}
